// socket-test.component.ts
import { Component, OnInit, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from '../../_services';
// import { SocketTestService } from '../../_services/socket-test.service';
import { RealtimeService } from '../../_services/realtime.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule],
  selector: 'app-socket-test',
  template: `
    <div class="container">
      <h2>Socket.IO Redis Adapter Test</h2>
      
      <div class="actions">
        <div class="form-group">
          <input [(ngModel)]="testMessage" placeholder="Mensagem de teste">
          <button (click)="runPingTest()">Testar Diretamente</button>
          <button (click)="runBroadcastTest()">Testar Broadcast</button>
          <button (click)="clearResults()">Limpar Resultados</button>
        </div>
      </div>
      
      <div class="results">
        <h3>Resultados dos Testes</h3>
        <div class="result-card" *ngFor="let result of testResults">
          <div class="header">
            <span [ngClass]="result.type">{{result.type}}</span>
            <span class="time">{{result.receivedAt | date:'HH:mm:ss.SSS'}}</span>
          </div>
          <div class="detail" *ngIf="result.type === 'direct-response'">
            <p><strong>Mensagem:</strong> {{result.data.originalMessage.message}}</p>
            <p><strong>Respondido por:</strong> {{result.data.respondedBy}} (direto)</p>
          </div>
          <div class="detail" *ngIf="result.type === 'server-response'">
            <p><strong>Mensagem:</strong> {{result.data.originalMessage.message}}</p>
            <p><strong>Respondido por:</strong> {{result.data.respondedBy}} (broadcast)</p>
          </div>
          <div class="detail" *ngIf="result.type === 'broadcast'">
            <p><strong>Mensagem:</strong> {{result.data.message}}</p>
            <p><strong>Enviado por cliente:</strong> {{result.data.clientId}}</p>
            <p><strong>Transmitido por:</strong> {{result.data.broadcastedBy}}</p>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .container { padding: 20px; }
    .actions { margin-bottom: 20px; }
    .form-group { display: flex; gap: 10px; }
    .results { max-height: 500px; overflow-y: auto; }
    .result-card { 
      border: 1px solid #ccc; 
      border-radius: 4px; 
      padding: 10px; 
      margin-bottom: 10px;
    }
    .header { 
      display: flex; 
      justify-content: space-between; 
      border-bottom: 1px solid #eee;
      padding-bottom: 5px;
      margin-bottom: 5px;
    }
    .direct-response { color: blue; }
    .server-response { color: green; }
    .broadcast { color: purple; }
  `]
})
export class SocketTestComponent implements OnInit {
  testMessage = 'Olá, isso é um teste!';
  testResults: any[] = [];
  private messageSubscription = null;
  
  constructor(private realTimeService: RealtimeService, private authService: AuthenticationService) {
    console.log('SocketTestComponent criado', realTimeService);
  }
  
  ngOnInit() {
    console.log('Service:', this.realTimeService);
    // this.messageSubscription = this.realTimeService.subscribe(this.authService.currentUserValue.selectedEmpresa._id).subscribe((results: any) => {
    //   this.testResults = results;
    // });
    this.realTimeService.getTestResults().subscribe((results: any) => {
      this.testResults = results;
    });
  }
  
  async runPingTest() {
    await this.realTimeService.pingTest(this.testMessage);
  }
  
  runBroadcastTest() {
    this.realTimeService.broadcastTest(this.testMessage);
  }
  
  clearResults() {
    this.realTimeService.clearResults();
  }
}